import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetBadgeCountResponseDto } from "../../dtos/get-badge-count-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimHistoryBadgeCountQueryParams = {
  options?: Omit<UseQueryOptions<GetBadgeCountResponseDto>, "queryKey">;
};

export const useGetClaimHistoryBadgeCountQuery = ({
  options
}: UseGetClaimHistoryBadgeCountQueryParams = {}) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimHistoryBadgeCount().queryKey,
    queryFn: async () => await OrderService.getClaimHistoryBadgeCount(),
    ...options
  });
};
